webpackJsonp([35783957827783],{

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _gatsbyLink = __webpack_require__(189);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(65);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(223);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: siteTitle }),
	      _react2.default.createElement(
	        'section',
	        { style: {
	            fontSize: '30px',
	            lineHeight: '1.5',
	            fontWeight: '400',
	            color: 'black',
	            marginBottom: '2em'
	          } },
	        'We are a small team dedicated to create unique presence for customers. We help startups, companies, and artists build for the web.'
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'faq' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Who are you?'
	          ),
	          ' ',
	          'A small team of developer and designer: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/mauryaratan' },
	            'Ram'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/JohnPixle' },
	            'John'
	          ),
	          ', and ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/lushkant' },
	            'Krishna'
	          ),
	          '. Together, we make beautiful WordPress themes and plugins.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'What do you do?'
	          ),
	          ' ',
	          'Primarily, we create awesome WordPress themes and plugins over at ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://codestag.com/?ref=dashwork' },
	            'Codestag'
	          ),
	          '. Focused towards minimal design and solid code.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'How old are you?'
	          ),
	          ' ',
	          'We\'ve been running Codestag successfully for over 5 years now, but we\'re just starting out as Dashwork where we plan to do more than just making themes and plugins.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'What technologies do you specialize in?'
	          ),
	          ' ',
	          'We\'re experienced with WordPress, PHP, JavaScript while keeping the latest tech in mind.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'How can I contact you?'
	          ),
	          ' ',
	          'If you\'d like to say hi, feel free to send us a tweet over at ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/dashworkio' },
	            '@dashworkio\u200F'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Check our ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects' },
	            'Projects'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { textAlign: 'center', marginTop: '2em' } },
	        '\uD83D\uDC4B'
	      )
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-700bfb53800c75df28f6.js